import React from 'react'
import { Container, Button } from 'react-bootstrap'
import AccordionList from './components/AccordionList'

import '../../../../assets/sass/pages/landing/pricing/components/faq-card.scss'

const FaqSection = ({
    title = "FAQs",
    questions = []
}) => {
    return (
        <div className="faq-section">
            <Container>
                <div className="info-container">
                    <h2 className="title">{title}</h2>
                </div>
                <AccordionList
                    list={questions} 
                    baseClassName="faq-card" 
                    titleKey="question"
                    contentKey="answer"
                />
                <Button variant="link" className="lg btn-xl">See More FAQs</Button>
            </Container>
        </div>
    )
}

export default FaqSection
